import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  Grid,
  InputBase,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import {
  DateRangePicker,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shortcuts } from "../../utils/Dates";
import { LoadingButton } from "@mui/lab";
import { GlobalContext } from "../../GlobalContext";
import { Context as TimeContext } from "../table/timecard/Context";
import { Context as EmplContext } from "../table/employees/Context";
import { Context as ScheContext } from "../table/schedule/Context";
import { Context as OverContext } from "../table/overtime/Context";
import { gettingEmployees, gettingSmartgroups } from "../../utils/Filter";

import SearchIcon from "@mui/icons-material/Search";

const Context = {
  employees: EmplContext,
  schedule: ScheContext,
  timecard: TimeContext,
  overtime: OverContext,
};

// Common
const FilterC = ({ view }) => {
  const { t } = useTranslation("filter");
  const { t: tUtils } = useTranslation("utils");

  const { handlerAlert } = useContext(GlobalContext);

  const {
    range1,
    setRange1,
    smartgroups,
    setSmartgroups,
    smartgroup,
    setSmartgroup,
    filter1,
    setFilter1,
    employees,
    setEmployees,
    employee,
    setEmployee,
    filter2,
    setFilter2,
    active,
    setActive,
    loadingGettingSmartgroups,
    setLoadingGettingSmartgroups,
    loadingGettingEmployees,
    setLoadingGettingEmployees,
    loadingGettingTimecard,
    loadingGettingInfoEmployees,
    loadingGettingSchedule,
    loadingGettingOpenPeriod,
    ready,
    setReady,
    renders,
    setRenders,
    searching,
  } = useContext(Context[view]);

  const gettingLoading = () => {
    let loading = true;
    switch (view) {
      case "employees":
        loading =
          loadingGettingSmartgroups ||
          loadingGettingEmployees ||
          loadingGettingInfoEmployees;

        return loading;

      case "schedule":
        loading =
          loadingGettingSmartgroups ||
          loadingGettingEmployees ||
          loadingGettingSchedule ||
          loadingGettingOpenPeriod;

        return loading;
      case "overtime":
        loading =
          loadingGettingSmartgroups ||
          loadingGettingEmployees ||
          loadingGettingTimecard ||
          loadingGettingSchedule ||
          loadingGettingOpenPeriod;

        return loading;
      case "timecard":
        loading =
          loadingGettingSmartgroups ||
          loadingGettingEmployees ||
          loadingGettingTimecard ||
          loadingGettingSchedule ||
          loadingGettingOpenPeriod;
        return loading;
      default:
        return loading;
    }
  };

  useEffect(() => {
    gettingSmartgroups(
      setLoadingGettingSmartgroups,
      setSmartgroups,
      setSmartgroup,
      view,
      handlerAlert,
    );
  }, [
    handlerAlert,
    setLoadingGettingSmartgroups,
    setSmartgroup,
    setSmartgroups,
    view,
  ]);

  useEffect(() => {
    if (smartgroup.length !== 0 && !loadingGettingSmartgroups) {
      gettingEmployees(
        setLoadingGettingEmployees,
        smartgroups,
        smartgroup,
        setEmployees,
        setEmployee,
        view,
        renders,
        range1,
        handlerAlert,
      );

      setReady(true);
    } else {
      setEmployees([]);
      setEmployee([]);
    }
  }, [
    smartgroup,
    smartgroups,
    setEmployee,
    setEmployees,
    setLoadingGettingEmployees,
    handlerAlert,
    view,
    setReady,
    loadingGettingSmartgroups,
    renders,
    range1,
  ]);

  useEffect(() => {
    if (
      employee.length !== 0 &&
      smartgroup.length !== 0 &&
      ready &&
      renders === 0 &&
      !loadingGettingSmartgroups &&
      !loadingGettingEmployees
    ) {
      searching();
      setReady(false);
      setRenders(1);
    }
  }, [
    employee,
    smartgroup,
    ready,
    renders,
    searching,
    view,
    setReady,
    setRenders,
    loadingGettingSmartgroups,
    loadingGettingEmployees,
  ]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 2,
          p: 1.5,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Grid container spacing={2}>
          {view === "employees" ? (
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="l-status">
                  {t("filter_common.columns.status.title")}
                </InputLabel>

                <Select
                  labelId="l-status"
                  id="status"
                  value={active}
                  label={t("filter_common.columns.status.title")}
                  onChange={(event) => {
                    setActive(event.target.value);
                  }}
                >
                  <MenuItem value={"all"}>
                    {t("filter_common.columns.status.all")}
                  </MenuItem>
                  <MenuItem value={"active"}>
                    {t("filter_common.columns.status.active")}
                  </MenuItem>
                  <MenuItem value={"inactive"}>
                    {t("filter_common.columns.status.inactive")}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          ) : (
            <Grid item xs={4}>
              <DateRangePicker
                label={t("filter_common.range_of_days")}
                slots={{ field: SingleInputDateRangeField }}
                slotProps={{
                  shortcuts: {
                    items: shortcuts(tUtils),
                  },
                }}
                format={
                  JSON.parse(sessionStorage.getItem("config")).date_format
                }
                calendars={1}
                fullwith
                onAccept={(value) => {
                  setRange1(value);
                }}
                value={range1}
                sx={{
                  width: "100%",
                }}
              />
            </Grid>
          )}

          <Grid item xs={3}>
            <FormControl
              fullWidth
              required
              error={smartgroup.length === 0 && !loadingGettingSmartgroups}
            >
              <InputLabel id="lsg">{t("filter_common.smartgroups")}</InputLabel>

              <Select
                labelId="lsg"
                id="sg"
                multiple
                value={smartgroup.map((sg) => sg.name)}
                input={<OutlinedInput label={t("filter_common.smartgroups")} />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={{
                  style: {
                    maxHeight: "400px",
                  },
                }}
              >
                {smartgroups.length !== 0 && !loadingGettingSmartgroups && (
                  <Box>
                    <Checkbox
                      sx={{ ml: 2 }}
                      checked={
                        filter1 === ""
                          ? smartgroups.filter((s) =>
                              smartgroup.map((s) => s.name).includes(s.name),
                            ).length === smartgroups.length
                          : smartgroups
                              .filter((sg) =>
                                sg.name
                                  .toLowerCase()
                                  .includes(filter1.toLocaleLowerCase()),
                              )
                              .every((sg) =>
                                smartgroup.map((s) => s.name).includes(sg.name),
                              )
                      }
                      indeterminate={
                        filter1 === ""
                          ? smartgroups.filter((s) =>
                              smartgroup.map((s) => s.name).includes(s.name),
                            ).length !== smartgroups.length &&
                            smartgroup.length > 0
                          : !smartgroups
                              .filter((sg) =>
                                sg.name
                                  .toLowerCase()
                                  .includes(filter1.toLocaleLowerCase()),
                              )
                              .every((sg) =>
                                smartgroup.map((s) => s.name).includes(sg.name),
                              ) &&
                            !smartgroups
                              .filter((sg) =>
                                sg.name
                                  .toLowerCase()
                                  .includes(filter1.toLocaleLowerCase()),
                              )
                              .every(
                                (sg) =>
                                  !smartgroup
                                    .map((s) => s.name)
                                    .includes(sg.name),
                              ) &&
                            smartgroups.filter((sg) =>
                              sg.name
                                .toLowerCase()
                                .includes(filter1.toLocaleLowerCase()),
                            ).length !== 0
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSmartgroup(
                            smartgroups
                              .filter((sg) =>
                                sg.name
                                  .toLowerCase()
                                  .includes(filter1.toLocaleLowerCase()),
                              )
                              .map((sg) => sg),
                          );
                        } else {
                          setSmartgroup(
                            smartgroup.filter(
                              (s) =>
                                !smartgroups
                                  .filter((sg) =>
                                    sg.name
                                      .toLowerCase()
                                      .includes(filter1.toLocaleLowerCase()),
                                  )
                                  .map((sg) => sg.name)
                                  .includes(s.name),
                            ),
                          );
                        }
                      }}
                    />

                    <InputBase
                      sx={{
                        width: "calc(100% - 80px)",
                        ml: 1,
                        mb: 1.5,
                      }}
                      placeholder="search..."
                      endAdornment={<SearchIcon sx={{ mr: 1 }} />}
                      value={filter1}
                      onChange={(e) => setFilter1(e.target.value)}
                    />

                    <Divider />

                    {smartgroups
                      .filter((sg) =>
                        sg.name
                          .toLowerCase()
                          .includes(filter1.toLocaleLowerCase()),
                      )
                      .map((sg) => (
                        <MenuItem
                          key={sg.id}
                          onClick={() => {
                            if (
                              smartgroup.filter((s) => s.name === sg.name)
                                .length > 0
                            ) {
                              setSmartgroup(
                                smartgroup.filter((s) => s.name !== sg.name),
                              );
                            } else {
                              setSmartgroup([...smartgroup, sg]);
                            }
                          }}
                        >
                          <Checkbox
                            checked={
                              smartgroup.filter((s) => s.name === sg.name)
                                .length > 0
                            }
                          />
                          <ListItemText primary={sg.name} />
                        </MenuItem>
                      ))}
                  </Box>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3}>
            <FormControl
              fullWidth
              error={employee.length === 0 && !loadingGettingEmployees}
            >
              <InputLabel id="lsg">{t("filter_common.employees")}</InputLabel>

              <Select
                labelId="lsg"
                id="sg"
                multiple
                value={employee.map((e) => e.full_name)}
                input={<OutlinedInput label={t("filter_common.employees")} />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={{
                  style: {
                    maxHeight: "400px",
                  },
                }}
              >
                {employees.length !== 0 && !loadingGettingEmployees && (
                  <Box>
                    <Checkbox
                      sx={{ ml: 2 }}
                      checked={
                        filter2 === ""
                          ? employees.filter((e) =>
                              employee
                                .map((e) => e.full_name)
                                .includes(e.full_name),
                            ).length === employees.length
                          : employees
                              .filter((e) =>
                                e.full_name
                                  .toLowerCase()
                                  .includes(filter2.toLocaleLowerCase()),
                              )
                              .every((em) =>
                                employee
                                  .map((e) => e.full_name)
                                  .includes(em.full_name),
                              )
                      }
                      indeterminate={
                        filter2 === ""
                          ? employees.filter((e) =>
                              employee
                                .map((e) => e.full_name)
                                .includes(e.full_name),
                            ).length !== employees.length && employee.length > 0
                          : !employees
                              .filter((em) =>
                                em.full_name
                                  .toLowerCase()
                                  .includes(filter2.toLocaleLowerCase()),
                              )
                              .every((em) =>
                                employee
                                  .map((e) => e.full_name)
                                  .includes(em.full_name),
                              ) &&
                            !employees
                              .filter((em) =>
                                em.full_name
                                  .toLowerCase()
                                  .includes(filter2.toLocaleLowerCase()),
                              )
                              .every(
                                (em) =>
                                  !employee
                                    .map((e) => e.full_name)
                                    .includes(em.full_name),
                              ) &&
                            employees.filter((em) =>
                              em.full_name
                                .toLowerCase()
                                .includes(filter2.toLocaleLowerCase()),
                            ).length !== 0
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setEmployee(
                            employees
                              .filter((em) =>
                                em.full_name
                                  .toLowerCase()
                                  .includes(filter2.toLocaleLowerCase()),
                              )
                              .map((em) => em),
                          );
                        } else {
                          setEmployee(
                            employee.filter(
                              (e) =>
                                !employees
                                  .filter((em) =>
                                    em.full_name
                                      .toLowerCase()
                                      .includes(filter2.toLocaleLowerCase()),
                                  )
                                  .map((em) => em.full_name)
                                  .includes(e.full_name),
                            ),
                          );
                        }
                      }}
                    />

                    <InputBase
                      sx={{
                        width: "calc(100% - 80px)",
                        ml: 1,
                        mb: 1.5,
                      }}
                      placeholder="search..."
                      endAdornment={<SearchIcon sx={{ mr: 1 }} />}
                      value={filter2}
                      onChange={(e) => setFilter2(e.target.value)}
                    />

                    <Divider />

                    {smartgroups
                      .filter((sg) =>
                        smartgroup.map((sg) => sg.name).includes(sg.name),
                      )
                      .map((sg) => (
                        <Box key={sg.id}>
                          <ListSubheader>{sg.name}</ListSubheader>

                          {employees
                            .filter((e) => e.smartgroup === sg.name)
                            .filter((e) =>
                              e.full_name
                                .toLowerCase()
                                .includes(filter2.toLocaleLowerCase()),
                            )
                            .sort((a, b) =>
                              a?.full_name.localeCompare(b?.full_name),
                            )
                            .map((e) => (
                              <MenuItem
                                key={`${e.id}-${e.smartgroup}`}
                                value={e.full_name}
                                onClick={() => {
                                  if (
                                    employee.filter(
                                      (emp) => emp.full_name === e.full_name,
                                    ).length > 0
                                  ) {
                                    setEmployee(
                                      employee.filter(
                                        (emp) => emp.full_name !== e.full_name,
                                      ),
                                    );
                                  } else {
                                    setEmployee([...employee, e]);
                                  }
                                }}
                              >
                                <Checkbox
                                  checked={
                                    employee.filter(
                                      (emp) => emp.full_name === e.full_name,
                                    ).length > 0
                                  }
                                />
                                <ListItemText primary={e.full_name} />
                              </MenuItem>
                            ))}
                        </Box>
                      ))}
                  </Box>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={2}>
            <LoadingButton
              sx={{ position: "absolute", right: "15px", height: "56px" }}
              //loading={loadingGettingSmartgroups || loadingGettingEmployees || loadingGettingTimecard || loadingGettingSchedule || loadingGettingOpenPeriod}
              loading={gettingLoading()}
              variant="contained"
              disabled={
                !range1[0]?.isValid() ||
                !range1[1]?.isValid() ||
                range1[0]?.isAfter(range1[1]) ||
                smartgroup.length === 0 ||
                employee.length === 0
              }
              onClick={searching}
              disableElevation
            >
              {t("filter_common.search.title")}
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export { FilterC };
